import { ReactNode } from 'react';
import { Alert, AlertDescription, AlertTitle, Box } from '@chakra-ui/react';
import { faEyes } from '@fortawesome/pro-regular-svg-icons';
import { MessageInbox } from '../../molecules/messageInbox';
import { SpinnerModal, Icon, ContentSkip } from 'shared-components';

import { IOpenedStudentsRecord } from '../../../store/dashboard/types';
import { UserRole } from '../../../store/auth/types';
import { IMessage } from 'api-paths-cas';

interface IProps {
  isLoading: boolean;
  userName: string;
  displayName: string;
  children: ReactNode;
  unreadMessagesCountToStudent: number;
  unreadMessagesCountFromStudent: number;
  unreadMessagesUniToAgent: number;
  unreadMessagesStudentToAgent: number;
  unreadMessagesAgentToUni: number;
  unreadMessagesUniSecure: number;
  messages: Array<IMessage>;
  onSubmitMessage: (message: IMessage) => void;
  markMessagesRead: (messageIds: Array<string>) => void;
  markMessageUnread: (messageId: string) => void;
  openedStudentRecords: ReadonlyArray<IOpenedStudentsRecord>;
  studentID?: string;
  role: UserRole;
  groups: Array<string>;
  visaAssistance: boolean;
  isAgent: boolean;
  hasAgentMessages: boolean;
  onLoadMessages: () => void;
}

function PageWrapper({
  isLoading,
  userName,
  displayName,
  children,
  messages,
  onSubmitMessage,
  markMessagesRead,
  markMessageUnread,
  openedStudentRecords,
  studentID,
  role: userRole,
  visaAssistance,
  isAgent,
  hasAgentMessages,
  onLoadMessages,
}: IProps) {
  // Filter records for this student, excluding current user and records with missing usernames
  const openedBy = openedStudentRecords.filter(
    record => record.studentNumber === studentID && record.userName && record.userName !== userName,
  );

  let isBeingViewedByVisible = false;
  let userNames = '';
  if (openedBy.length > 0) {
    const allUserNames = openedBy.map(record => record.userName);
    isBeingViewedByVisible = true;
    userNames = allUserNames.length === 1 ? allUserNames[0] : allUserNames.join(', ');
  }

  return (
    <>
      <SpinnerModal show={isLoading} />

      <ContentSkip />

      <Box data-selector="content-wrap" ml={{ base: 0, md: 'navbarWidth' }}>
        {isBeingViewedByVisible ? (
          <Alert
            status="info"
            colorScheme="violet"
            data-selector="being-viewed-by"
            borderRadius={0}
            px={{ base: 8, xl: 12 }}
            ml={{ md: 'sidebarWidth' }}
          >
            <Icon icon={faEyes} colorScheme="violet" mr={3} />

            <AlertTitle>Record currently being viewed by:</AlertTitle>

            <AlertDescription>{userNames}</AlertDescription>
          </Alert>
        ) : null}

        {children}

        <MessageInbox
          messages={messages}
          onSubmitMessage={onSubmitMessage}
          markMessagesRead={markMessagesRead}
          markMessageUnread={markMessageUnread}
          userName={userName}
          displayName={displayName}
          role={userRole}
          visaAssistance={visaAssistance}
          isAgent={isAgent}
          hasAgentMessages={hasAgentMessages}
          onLoadMessages={onLoadMessages}
        />
      </Box>
    </>
  );
}

export default PageWrapper;
